

export enum AppState {
    home,
    chat,
    allConversations
}

export enum ChatState {
    newConversation,
    continueConversation
}

export enum Chat {
    Message,
    Fragment
}

export enum WindowArticleState {
    collections,
    collectionItems,
    search
}